import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import * as endpoints from './endpoints';
import {
  addLeave,
  addLeaveSuccess,
  addLeaveFailed,
  getLeaves,
  getLeavesSuccess,
  getLeavesFailed,
  updateLeaveStatus,
  updateLeaveStatusSuccess,
  updateLeaveStatusFailed,
  updateLeave,
  updateLeaveSuccess,
  updateLeaveFailed,
  getLeaveDetails,
  getLeaveDetailsFailed,
  getLeaveDetailsSuccess,
  sendLeave,
  sendLeaveSuccess,
  sendLeaveFailed,
  sendToManager,
  sendToManagerSuccess,
  sendToManagerFailed,
  getUsers,
  getUsersSuccess,
  getUsersFailed,
  addExistingLeave,
  addExistingLeaveSuccess,
  addExistingLeaveFailed,
} from './slice';
import { request } from '@app/services';
import { RootState } from '@app/redux/root-reducer';
function* addLeaveSaga(action: ReturnType<typeof addLeave>): any {
  try {
    const { leaveType, from, to, reason, periods, attachment } = action.payload;
    const formData = new FormData();
    formData.append('leaveType', leaveType);
    formData.append('from', from);
    formData.append('to', to);
    formData.append('reason', reason);
    formData.append('periods', JSON.stringify(periods));
    if (attachment) {
      formData.append('image', attachment);
    }
    const result = yield call(request.post, endpoints.addLeave, formData);
    yield put(addLeaveSuccess(result.data));
    yield put(getLeaves(true));
  } catch (err) {
    yield put(addLeaveFailed(err));
  }
}
//
function* getLeavesSaga(action: ReturnType<typeof getLeaves>): any {
  try {
    const itSelf = action.payload;
    const result = yield call(request.get, endpoints.getLeaves, {
      params: {
        itSelf,
      },
    });
    yield put(getLeavesSuccess(result.data));
  } catch (err) {
    yield put(getLeavesFailed(err));
  }
}
//
function* updateLeaveStatusSaga(action: ReturnType<typeof updateLeaveStatus>): any {
  try {
    const { id, req, reason } = action.payload;
    const { data } = yield select((store: RootState) => store.leavesReducer.leaves);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateLeaveStatus}${id}`, {
      update: req,
      reasonOfDecline: reason,
    });
    yield put(updateLeaveStatusSuccess(result.data));
    const updatedLeaves = data?.map((leaves: { id: number; status: string }) => {
      if (leaves.id === id) {
        return {
          ...leaves,
          update: req,
        };
      }
      return leaves;
    });
    yield put(getLeavesSuccess(updatedLeaves));
    yield put(getLeaveDetails({ id }));
  } catch (err) {
    yield put(updateLeaveStatusFailed(err));
  }
}
//
function* sendToManagerSaga(action: ReturnType<typeof sendToManager>): any {
  try {
    const { id, req } = action.payload;
    const { data } = yield select((store: RootState) => store.leavesReducer.leaves);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.sendToManager}${id}`, {
      update: req,
    });
    if (result) {
      const updatedLeaves = data?.map((leaves: { id: number; status: string }) => {
        if (leaves.id === id) {
          return {
            ...leaves,
            update: req,
          };
        }
        return leaves;
      });
      yield put(sendToManagerSuccess(result));
      yield put(getLeavesSuccess(updatedLeaves));
    }
  } catch (err) {
    yield put(sendToManagerFailed(err));
  }
}
//
function* updateLeaveSaga(action: ReturnType<typeof updateLeave>): any {
  try {
    const { id, leaveType, from, to, reason, periods, attachment } = action.payload;
    const formData = new FormData();
    formData.append('leaveType', leaveType);
    formData.append('from', from);
    formData.append('to', to);
    formData.append('reason', reason);
    formData.append('periods', JSON.stringify(periods));
    if (attachment) {
      formData.append('image', attachment);
    }
    if (id) {
      formData.append('id', `${id}`);
    }

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateLeave}${id}`, formData);
    yield put(updateLeaveSuccess(result.data.data));
  } catch (err) {
    yield put(updateLeaveFailed(err));
  }
}
function* getLeaveDetailsSaga(action: ReturnType<typeof getLeaveDetails>): any {
  try {
    const { id } = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getLeaveDetails}${id}`);
    yield put(getLeaveDetailsSuccess(result.data));
  } catch (err) {
    yield put(getLeaveDetailsFailed(err));
  }
}
//

//
function* sendLeaveSaga(action: ReturnType<typeof sendLeave>): any {
  try {
    const { id, leaveType, from, to, reason, periods, attachment } = action.payload;
    const formData = new FormData();
    formData.append('leaveType', leaveType);
    formData.append('from', from);
    formData.append('to', to);
    formData.append('reason', reason);
    formData.append('periods', JSON.stringify(periods));
    if (attachment) {
      formData.append('image', attachment);
    }
    if (id) {
      formData.append('id', `${id}`);
    }
    const result = yield call(request.post, endpoints.sendLeave, formData);
    yield put(sendLeaveSuccess(result.data));
    yield put(getLeaves(true));
  } catch (err) {
    yield put(sendLeaveFailed(err));
  }
}
//
function* getUsersSaga(action: ReturnType<typeof getUsers>): any {
  try {
    const result = yield call(request.get, endpoints.getUsers);
    yield put(getUsersSuccess(result.data));
  } catch (err) {
    yield put(getUsersFailed(err));
  }
}
//
function* addExistingLeaveSaga(action: ReturnType<typeof addExistingLeave>): any {
  try {
    const { name, approvedBy, to, from, leaveType, attachment, id, periods, reason } =
      action.payload;
    const formData = new FormData();
    formData.append('leaveType', leaveType);
    formData.append('from', from);
    formData.append('to', to);
    formData.append('reason', reason);
    formData.append('periods', JSON.stringify(periods));
    if (attachment) {
      formData.append('image', attachment);
    }
    if (id) {
      formData.append('id', `${id}`);
    }
    const result = yield call(
      request.post,
      `${endpoints.addExistingLeave}/${name}/${approvedBy}`,
      formData
    );
    yield put(addExistingLeaveSuccess(result.data));
    yield put(getLeaves(true));
  } catch (err) {
    yield put(addExistingLeaveFailed(err));
  }
}
function* leaveSagas() {
  yield all([
    takeLatest(updateLeave, updateLeaveSaga),
    takeLatest(addLeave, addLeaveSaga),
    takeLatest(sendLeave, sendLeaveSaga),
    takeLatest(sendToManager, sendToManagerSaga),
    takeLatest(updateLeaveStatus, updateLeaveStatusSaga),
    takeLatest(getLeaveDetails, getLeaveDetailsSaga),
    takeLatest(getUsers, getUsersSaga),
    takeLatest(addExistingLeave, addExistingLeaveSaga),
    takeLatest(
      [getLeaves, addLeaveSuccess, updateLeaveSuccess, updateLeaveStatusSuccess],
      getLeavesSaga
    ),
  ]);
}

export { leaveSagas };
